import { useEffect } from "react";
import { useCookieConsent } from "../../context/CookieContext";
import { initializeGA } from "../../utility/analytics/initializeGA";

const MEASUREMENT_ID = "G-J1C2EBVNWH";

const GoogleAnalyticsScript = () => {
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (consent && consent.analytics) {
      initializeGA(MEASUREMENT_ID);
    }
  }, [consent]);

  return null;
};

export default GoogleAnalyticsScript;
